module.exports = __webpack_public_path__ + "images/0d1cd5f39b1875949e211d6e29d72c26.svg";